import Color from 'color';
import { normal } from 'color-blend';

const getRGBA = color => {
  const { r, g, b, alpha } = color.object();
  const a = alpha === undefined ? 1 : alpha;
  return { r, g, b, a };
};

const getRGBAlpha = color => {
  const { r, g, b, a } = color;
  const alpha = a === undefined ? 1 : a;
  return { r, g, b, alpha };
};

/**
 * @param {string} colorA opaque base color
 * @param {string} colorB color with alpha channel lower than 1
 * @returns {string} blended color
 */
const blendColors = (colorA, colorB) => {
  const resolvedColorA = Color(colorA);
  const resolvedColorB = Color(colorB);
  return Color(getRGBAlpha(normal(getRGBA(resolvedColorA), getRGBA(resolvedColorB)))).string();
};

export default blendColors;
